import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput, Typography } from '@guildeducationinc/recess';
import { DeadlineDateType } from '@src/types';
import { DropdownSelect, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const DeadlineInput = ({ label, value, onChange, includeStart, includeEnd, readonly, className, direction, }) => {
    const { t } = useLocale();
    const dateOptions = useMemo(() => {
        const options = [];
        if (includeEnd) {
            options.push({ value: DeadlineDateType.END_DATE, label: t('End Date') });
        }
        if (includeStart) {
            options.push({ value: DeadlineDateType.START_DATE, label: t('Start Date') });
        }
        return options;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [includeStart, includeEnd]);
    const directionOptions = useMemo(() => {
        const options = [];
        if (direction === 'BEFORE_ONLY') {
            options.push({ value: 'before', label: t('Before') });
        }
        else if (direction === 'AFTER_ONLY') {
            options.push({ value: 'after', label: t('After') });
        }
        else {
            options.push({ value: 'before', label: t('Before') });
            options.push({ value: 'after', label: t('After') });
        }
        return options;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [direction]);
    if (readonly) {
        _jsx("div", { className: className, children: _jsx(Typography, { variant: 'label1', children: label }) });
    }
    return (_jsxs("div", { className: className, children: [_jsx(Typography, { variant: 'label1', children: label }), _jsxs("div", { className: 'flex gap-2 items-center', children: [_jsx(TextInput, { label: t('Days'), hideLabel: true, value: value.days ?? '', onChange: event => onChange({
                            ...value,
                            days: event.target.value !== '' ? event.target.value : undefined,
                        }), append: t('Days'), className: 'w-36', disabled: readonly }), _jsx(DropdownSelect, { label: t('Before/After'), hideLabel: true, options: directionOptions, value: value.backward === false ? 'after' : 'before', onChange: event => onChange({
                            ...value,
                            backward: event.selection?.value !== 'after',
                        }), disabled: readonly, isClearable: false }), _jsx(DropdownSelect, { label: t('Date field'), options: dateOptions, value: value.basedOn, onChange: event => onChange({
                            ...value,
                            basedOn: event.selection?.value,
                        }), disabled: readonly, isClearable: false })] })] }));
};
